export default __webpack_public_path__ + "static/media/review-img-2.b5ae1c5d.png";